export const getRandInt = (max, min = 0) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
export const getRandIntExclusive = (max, min = -1) =>
  getRandInt(max - 1, min + 1);

export const getDecimalChance = (decimal) => getRandInt(100) < decimal * 100;

export const safeParseInt = (val, defaultVal) => {
  const newValue = parseInt(val);

  return isNaN(newValue) ? defaultVal : newValue;
};

export const nilIfNaN = (val) => (isNaN(val) ? undefined : val);
